<script setup lang="ts">
  withDefaults(
    defineProps<{ spanLeft?: number; spanCenter?: number; spanRight?: number; gap?: number; cols?: number }>(),
    {
      spanLeft: 3,
      spanCenter: 6,
      spanRight: 3,
      gap: 4,
      cols: 12,
    },
  );
</script>

<template>
  <div
    :class="`grid w-full h-[calc(100vh-100px)] gap-${gap} print:h-auto`"
    :style="{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }">
    <div
      class="h-full overflow-hidden print:h-auto print:overflow-visible"
      :style="spanLeft ? { gridColumn: `span ${spanLeft}` } : { display: 'none' }">
      <slot name="left" />
    </div>
    <div
      class="h-full overflow-y-auto print:h-auto print:overflow-visible"
      :style="spanCenter ? { gridColumn: `span ${spanCenter}` } : { display: 'none' }">
      <slot name="center" />
    </div>
    <div
      class="h-full overflow-hidden print:h-auto print:overflow-visible"
      :style="spanRight ? { gridColumn: `span ${spanRight}` } : { display: 'none' }">
      <slot name="right" />
    </div>
  </div>
</template>
